export const MULTISELECT_OVERRIDE_STRINGS = {
  selectSomeItems: "Tutte le categorie",
  allItemsAreSelected: "Hai selezionato tutte le categorie",
  search: "Cerca",
  noOptions: "Nessuna categoria",
  clearSearch: "Cancella ricerca",
  clearSelected: "Cancella selezione",
};
